module.exports = __webpack_public_path__ + "static/media/brand-refresh-cash-icon.b63c9c73.svg";